<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      border
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this), format: format }
  },
  computed: {
    height() {
      const minHeight = 1000
      const height = this.tableHeight - 40
      return height < minHeight ? minHeight : height
    },
  },
}
</script>
